import { render } from "./MySales.vue?vue&type=template&id=dcd19898&scoped=true"
import script from "./MySales.vue?vue&type=script&lang=js"
export * from "./MySales.vue?vue&type=script&lang=js"

import "./MySales.vue?vue&type=style&index=0&id=dcd19898&scoped=true&lang=css"

import exportComponent from "/var/www/vhosts/jahajibd.com/ia.jahajibd.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dcd19898"]])

export default __exports__